var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 12L12.7073 11.2929C12.5197 11.1054 12.2654 11 12.0002 11C11.7349 11 11.4806 11.1053 11.293 11.2929L12.0001 12ZM11.0001 22C11.0001 22.5523 11.4479 23 12.0001 23C12.5524 23 13.0001 22.5523 13.0001 22H11.0001ZM8.29291 14.2929C7.90238 14.6834 7.90236 15.3166 8.29288 15.7071C8.68339 16.0976 9.31656 16.0976 9.70709 15.7071L8.29291 14.2929ZM14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L14.2929 15.7071ZM7 8V9H8V8H7ZM17 8H16V9H17V8ZM18 8V7V8ZM11.0001 12V22H13.0001V12H11.0001ZM11.293 11.2929L8.29291 14.2929L9.70709 15.7071L12.7072 12.7071L11.293 11.2929ZM11.293 12.7071L14.2929 15.7071L15.7071 14.2929L12.7073 11.2929L11.293 12.7071ZM8 17H6V19H8V17ZM6 9H7V7H6V9ZM8 8V7H6V8H8ZM16 7V8H18V7H16ZM17 9H18V7H17V9ZM18 17H16V19H18V17ZM22 13C22 15.2091 20.2091 17 18 17V19C21.3137 19 24 16.3137 24 13H22ZM12 3C14.2091 3 16 4.79086 16 7H18C18 3.68629 15.3137 1 12 1V3ZM8 7C8 4.79086 9.79086 3 12 3V1C8.68629 1 6 3.68629 6 7H8ZM18 9C20.2091 9 22 10.7909 22 13H24C24 9.68629 21.3137 7 18 7V9ZM2 13C2 10.7909 3.79086 9 6 9V7C2.68629 7 0 9.68629 0 13H2ZM6 17C3.79086 17 2 15.2091 2 13H0C0 16.3137 2.68629 19 6 19V17Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUploadImage);
export default __webpack_public_path__ + "static/media/ic_upload_image.84f08b7a990433c3c9b9394345fffa62.svg";
export { ForwardRef as ReactComponent };